export default "__VITE_ASSET__4jozSdoz__"